







































































































































































declare var window: any;
import { Component, Vue, Mixins } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import CardHeader from '@/components/Registration/Header.vue';
import Container from '@/components/Registration/Container.vue';
import RegistrationCard from '@/components/Registration/Card.vue';
import BasicSignupForm from './BasicSignupForm.vue';
import SignupFooter from './Footer.vue';
import { ResumePayload } from '../../models/jobs/resumepayload';
import { EngineerSignUP } from '../../models/jobrolesignup/engineersignup';
import basicFormValidator from './basicFormValidator';
import { User } from '../../models/userdata/userdto';
import { LicenceSave } from '@/models/licence/LicenseSave';
import { ModelListSelect } from 'vue-search-select';
import MultipleSelectWithCheckbox from '@/components/Commons/MultipleSelectWithCheckbox.vue';
import { airlineCompanies } from './airlineCompanies';
import Multiselect from 'vue-multiselect';
import resumeValidator from './resumeValidator';
@Component({
  components: {
    CardHeader,
    Container,
    RegistrationCard,
    BasicSignupForm,
    SignupFooter,
    MultipleSelectWithCheckbox,
    ModelListSelect,
    Multiselect,
  },
})
export default class EngineerSignup extends Mixins(
  basicFormValidator,
  resumeValidator,
) {
  $wlToastr: any;
  private basicFormValues = new User();
  //private resumePayload: ResumePayload = new ResumePayload();
  private engineerSignUP: EngineerSignUP = new EngineerSignUP();
  private supportedFileSize = 0;
  private errorString = '';
  private apiResponseMessages: any[] = [];
  private engineerFormErrors = {
    resume: '',
    mostCurrentAirframe: '',
    latestRank: '',
    mostRecentEmployer: '',
    currentEngineType: '',
    currentJobTitle: '',

    licenceType: '',
    licenceAuthority: '',
    licenceCountry: '',

    passportCountry: '',
    otherPassportCountry: '',
    otherRecentAirframe: '',
  };
  private updatedSections: any = [];

  addTag(newTag) {
    const tag = {
      text: newTag,
      value: newTag,
    };
    this.airlineCompanies.push(tag);
    this.engineerSignUP.mostRecentEmployer = tag;
  }

  validateEngineerForm() {
    this.engineerFormErrors = {
      resume: '',
      mostCurrentAirframe: '',
      latestRank: '',
      mostRecentEmployer: '',
      currentEngineType: '',
      currentJobTitle: '',

      licenceType: '',
      licenceAuthority: '',
      licenceCountry: '',

      passportCountry: '',
      otherPassportCountry: '',
      otherRecentAirframe: '',
    };
    const inputformat = /^([a-zA-z0-9'-. ,]+)$/;
    const emailformat = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    let isValid: boolean = true;

    // if (this.resumePayload.resume.resumename === '') {
    //   this.engineerFormErrors.resume = 'signup.resume.required';
    // }

    if (!this.engineerSignUP.mostCurrentAirframe) {
      this.engineerFormErrors.mostCurrentAirframe =
        'signup.mostCurrentAirframe.required';
    }

    if (!this.engineerSignUP.latestRank) {
      this.engineerFormErrors.latestRank = 'signup.latestrank.required';
    }

    if (!this.engineerSignUP.mostRecentEmployer.value) {
      this.engineerFormErrors.mostRecentEmployer = 'signup.employer.required';
    }

    if (!this.engineerSignUP.currentEngineType) {
      this.engineerFormErrors.currentEngineType =
        'signup.currentengine.required';
    }

    if (!this.engineerSignUP.licenceType.value) {
      this.engineerFormErrors.licenceType = 'signup.licenceType.required';
    }

    if (!this.engineerSignUP.licenseAuthority) {
      this.engineerFormErrors.licenceAuthority =
        'signup.licenceAuthority.required';
    }

    if (!this.engineerSignUP.licenceCountry.countryId) {
      this.engineerFormErrors.licenceCountry = 'signup.licencecountry.required';
    }

    if (this.engineerSignUP.passportCountries.length < 1) {
      this.engineerFormErrors.passportCountry = 'signup.passport.required';
    }

    // if (!this.engineerSignUP.otherPassportCountryId) {
    //   this.engineerFormErrors.otherPassportCountry =
    //     'signup.otherPassport.required';
    // }

    // if (!this.engineerSignUP.otherRecentAirframe) {
    //   this.engineerFormErrors.otherRecentAirframe =
    //     'signup.othetRecentAirframe.required';
    // }

    Object.keys(this.engineerFormErrors).forEach((key) => {
      isValid = isValid && !this.engineerFormErrors[key];
    });
    return isValid;
  }

  get tagLine() {
    return vxm.configs.getGlobalConfigValue('WL_COMPANY_TAG_LINE')
  }

  get airlineCompanies() {
    return vxm.roleSignup.ChildCompanies.map((opt) => {
      return {
        value: opt.name,
        text: opt.name,
      };
    });
  }

  get passportCountries() {
    return vxm.passport.CountryList;
  }

  get licenseTypeOptions() {
    return vxm.roleSignup.EngineerLicenceCategories;
  }

  get licenseAuthorityOptions() {
    return vxm.configs.getGlobalConfigValue('LICENCE_AUTHORITY').map((opt) => {
      return {
        value: opt,
        text: opt,
      };
    });
  }

  updatePassportCountries(newValue, oldValue) {
    this.engineerSignUP.passportCountries = [];
    newValue.forEach((element) => {
      this.engineerSignUP.passportCountries.push(element.countryId);
    });
  }

  async mounted() {
    this.updatedSections = [];
    vxm.roleSignup.setMarketingMail(false);
    await vxm.passport.fetchCountryList();
    vxm.roleSignup.fetchEngineerLicenseCategory();
    vxm.roleSignup.fetchJobHistoryMetaData();
    vxm.roleSignup.fetchChildCompanies();
    this.supportedFileSize = vxm.utility.fileUploadMaxSize;
  }

  get rankOptions() {
    return vxm.roleSignup.EngineerRankOptions;
  }

  get equipmentTypeOptions() {
    return vxm.roleSignup.EquipmentTypeOptions;
  }

  get countryList() {
    return vxm.passport.CountryList;
  }

  get licenceList() {
    return vxm.licence.LicenceList;
  }

  get airframesList() {
    return vxm.roleSignup.EngineerFleetOptions;
  }

  get engineTypeList() {
    return vxm.configs.getGlobalConfigValue('ENGINE_TYPE');
  }

  get licenceAuthorityList() {
    return vxm.configs.getGlobalConfigValue('LICENCE_AUTHORITY');
  }

  capitalize(input: string) {
    var words = input.split(' ');
    var CapitalizedWords: string[] = [];
    words.forEach((element) => {
      CapitalizedWords.push(
        element[0].toUpperCase() +
          element.slice(1, element.length).toLowerCase(),
      );
    });
    return CapitalizedWords.join(' ');
  }

  validateFileFormate() {
    const vm = this;
    setTimeout(() => vm.validationFileFormatResume(), 50);
  }

  validationFileFormatResume() {
    const vm = this;
    console.log([vm.resumePayload]);
    this.resumePayload.resume.resumename = vm.resumePayload.resumefile.name;
    if (this.resumePayload.resume.resumename.length > 45) {
      this.$wlToastr(
        'error',
        'You have exceeded the maximum character limit of 45 characters for file name',
        this.$t('ResumeDetails_UploadResume'),
      );
      return;
    }

    const ext = vm.resumePayload.resumefile.name.match(/\.([^\.]+)$/)[1];
    const fileNameFormat = vm.resumePayload.resumefile.name.match(
      /\.([^\.]+)$/,
    )[0];
    const allowedResumeFormat = vxm.configs.getGlobalConfigValue(
      'ALLOWED_RESUME_FORMATS',
    );
    if (!allowedResumeFormat.includes(ext)) {
      this.$wlToastr(
        'error',
        fileNameFormat +
          ` is an unsupported file format. Following file formats are allowed: ${allowedResumeFormat}`,
        this.$t('ResumeDetails_UploadResume'),
      );
      vm.resumePayload.resumefile = '';
    }
  }

  async registerUser() {
    const basicFormValid = this.validateBasicForm(this.basicFormValues);
    const engineerFormValid = this.validateEngineerForm();
    this.resumeErrorMessage = '';
    this.resumePayload.resumefile && this.validationFileFormatResume();
    if (this.resumeErrorMessage) {
      return;
    }
    if (basicFormValid && engineerFormValid) {
      let resp: any;
      let formData: FormData = new FormData();
      try {
        resp = await vxm.roleSignup.basicSignup(this.basicFormValues);
        console.log('Response of signup is', resp);
        if (resp.success) {
          await vxm.users.refreshProfileInfo();
          let userProfile: any = vxm.users.myUserProfile;
          userProfile.notificationTypeMap = {
            ...userProfile.notificationTypeMap,
            MARKETING_EMAIL: vxm.roleSignup.MarketingEmail,
          };
          userProfile.doNotTriggerEvent = 'true';
          const licenceData = {
            licenceMasterId: Number(this.engineerSignUP.licenceType.value),
            licenceName: this.engineerSignUP.licenceType.text,
            licenceCountry: this.engineerSignUP.licenceCountry.name,
            licenceAuthority: this.engineerSignUP.licenseAuthority,
            licenceOn: this.engineerSignUP.mostCurrentAirframe,
            doNotTriggerEvent: 'true',
          };
          const jobHistoryData = {
            doNotTriggerEvent: 'true',
            currentJob: true,
            companyInfo: {
              companyName: this.engineerSignUP.mostRecentEmployer.value,
            },
            jobRole: this.engineerSignUP.currentJobTitle,
            jobHistoryCustomData: {
              [vxm.roleSignup.CustomFieldMappings.role]: 'Engineer',
              [vxm.roleSignup.CustomFieldMappings.aircraftAirframe]: this
                .engineerSignUP.mostCurrentAirframe,
              [vxm.roleSignup.CustomFieldMappings.equipmentType]: this
                .engineerSignUP.currentEngineType,
              [vxm.roleSignup.CustomFieldMappings.rank]: this.engineerSignUP
                .latestRank,
            },
            startDTTM: new Date().getTime(),
          };
          const passportData = this.engineerSignUP.passportCountries.map(
            (element) => ({
              identificationMasterId: element,
              doNotTriggerEvent: 'true',
            }),
          );
          const resumeFile = this.resumePayload.resumefile;
          formData = new FormData();
          formData.append('userProfileData', JSON.stringify(userProfile));
          formData.append('licenceData', JSON.stringify(licenceData));
          formData.append('jobHistoryData', JSON.stringify(jobHistoryData));
          formData.append('passportData', JSON.stringify(passportData));
          resumeFile && formData.append('resumefile', resumeFile);
        }
      } catch (error) {
        vxm.roleSignup.trackMegaSignupFailure({
          payload: this.basicFormValues,
          error,
          stage: 'preMegaSignup',
        });
        this.$wlToastr(
          'error',
          'Something went wrong while signing up. Please try again.',
          'Sign up',
        );
        return;
      }
      if (resp.success) {
        const response = await vxm.roleSignup.megaSignup(formData);
        if (response.meta && response.meta.success) {
          this.$router.push('home');
          this.$wlToastr(
            'success',
            'You have successfully signed up',
            'Sign up',
          );
          if (response.data) {
            if (!response.data.jobHistoryData) {
              this.$wlToastr(
                'error',
                'Work experience information not saved. Please try again from Work experience section.',
                'Sign up',
              );
            }
            if (!response.data.licenceData) {
              this.$wlToastr(
                'error',
                'Licence information not saved. Please try again from licence section.',
                'Sign up',
              );
            }
            if (!response.data.passportData) {
              this.$wlToastr(
                'error',
                'Passport information not saved. Please try again from Passport section.',
                'Sign up',
              );
            }
            if (!response.data.userProfileData) {
              this.$wlToastr(
                'error',
                'Profile information not saved. Please try again from profile section.',
                'Sign up',
              );
            }
            if (!response.data.resumeFile) {
              this.$wlToastr(
                'error',
                'Resume is not saved. Please try again from profile section.',
                'Sign up',
              );
            }
          }
        }
      } else {
        this.$wlToastr('error', resp.errorMessage, 'Sign up');
      }
    }
  }

  validateFileSize(file) {
    console.log('validating file size for file : ', file);
    if (file.size > this.supportedFileSize) {
      this.$wlToastr(
        'error',
        this.$t('ResumeDetails_SizeRestriction', { maxSize: this.supportedFileSize / (1024 * 1024) }),
        this.$t('ResumeDetails_UploadResume'),
      );
      return false;
    }
    return true;
  }

  validateUploadResume(resumePayload: ResumePayload): boolean {
    if (!resumePayload.resume.resumename) {
      this.errorString = 'profile.upload.resume.file.required';
      return false;
    }
    if (resumePayload.resume.resumename.length > 250) {
      this.errorString = 'profile.resume.file.name.exceeded';
      return false;
    }

    return true;
  }

  async uploadResume() {
    const vm = this;
    if (!this.resumePayload.resume.resumename) {
      return;
    }
    const token = vxm.users.getToken;
    this.resumePayload.accessToken = token;
    this.resumePayload.jobpostingid = -1;
    this.resumePayload.resumelink = '';
    console.log(this.resumePayload);

    if (this.validateFileSize(this.resumePayload.resumefile)) {
      if (this.validateUploadResume(this.resumePayload)) {
        const respPromise = await vxm.roleSignup.uploadResume(
          this.resumePayload,
        );
        if (respPromise.data.success) {
          var successResp = {
            status: 'success',
            message: 'Upload resume',
            category: 'Upload Resume',
          };
          this.apiResponseMessages.push(successResp);
        } else {
          this.$wlToastr(
            'error',
            this.$t('profile.upload.resume.error'),
            this.$t('ResumeDetails_UploadResume'),
          );
        }
      } else {
        this.$wlToastr('error', this.$t(this.errorString), this.$t('ResumeDetails_UploadResume'));
      }
    }
    this.resumePayload.resumefile = '';
  }

  //to save selected passport
  async saveSelectedPassport() {
    const responses = this.engineerSignUP.passportCountries.map((element) => {
      return vxm.passport.saveSelectedPassport({
        identificationMasterId: element,
        isPartofRegistration: true,
      });
    });
    Promise.all(responses).then((results) => {
      const success = results.every(
        (result: any) => result.meta && result.meta.success,
      );
      if (!success) {
        this.$wlToastr(
          'error',
          'Passport information not saved. Please try again from Passport section.',
          'Sign up',
        );
        //vxm.roleSignup.triggerMegaEvent(this.updatedSections);
      } else {
        this.updatedSections.push('EVENT_CODE_USER_IDENTIFICATION_ADD');
        //vxm.roleSignup.triggerMegaEvent(this.updatedSections);
      }
    });
  }

  async activateLicence() {
    const licenceSave = new LicenceSave();
    licenceSave.licenceMasterId = Number(this.engineerSignUP.licenceType.value);
    licenceSave.licenceName = this.engineerSignUP.licenceType.text;
    licenceSave.licenceAuthority = this.engineerSignUP.licenseAuthority;
    licenceSave.licenceOn = this.engineerSignUP.mostCurrentAirframe;
    licenceSave.licenceCountry = this.engineerSignUP.licenceCountry.name;
    const vm = this;
    const respPromise: any = vxm.roleSignup.saveLicenceInfo(licenceSave);
    const resp = await respPromise;
    if (resp.meta.success) {
      var successResp = {
        status: 'success',
        message: 'License Selected Successfully',
        category: 'License',
      };
      this.apiResponseMessages.push(successResp);
      this.updatedSections.push('EVENT_CODE_USER_LICENSE_ADD');
    } else {
      var successResp = {
        status: 'error',
        message: 'Licence Activation Failed',
        category: 'License',
      };
      this.apiResponseMessages.push(successResp);
    }
  }

  async updateJobHistory() {
    const response = await vxm.roleSignup.saveJobHistory({
      currentJob: true,
      companyInfo: {
        companyName: this.engineerSignUP.mostRecentEmployer.value,
      },
      jobRole: this.engineerSignUP.currentJobTitle,
      jobHistoryCustomData: {
        [vxm.roleSignup.CustomFieldMappings.role]: 'Engineer',
        [vxm.roleSignup.CustomFieldMappings.aircraftAirframe]: this
          .engineerSignUP.mostCurrentAirframe,
        [vxm.roleSignup.CustomFieldMappings.equipmentType]: this.engineerSignUP
          .currentEngineType,
        [vxm.roleSignup.CustomFieldMappings.rank]: this.engineerSignUP
          .latestRank,
      },
      startDTTM: new Date().getTime(),
    });
    if (vxm.jobs.UserJobHistoryUpdateResponse.meta['success']) {
      var successResp = {
        status: 'success',
        message: 'Work Experience Creation Successful',
        category: 'Work Experience',
      };
      this.apiResponseMessages.push(successResp);
      this.updatedSections.push('EVENT_CODE_JOB_HISTORY_ADD');
    } else {
      var successResp = {
        status: 'success',
        message: 'Work Experience Creation failed',
        category: 'Work Experience',
      };
      this.apiResponseMessages.push(successResp);
    }
  }
}
